import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { getProduct } from "@/lib/products";
import AgentePersonalizado from "@/pages/AgentePersonalizado";

export const Route = createFileRoute("/agente-personalizado")({
  head: () => buildHead({
    title: `${getProduct("agente-personalizado")!.name} — OP2P CRM e Agentes de IA`,
    description: `${getProduct("agente-personalizado")!.tagline} ${getProduct("agente-personalizado")!.description}`,
    path: "/agente-personalizado",
  }),
  component: AgentePersonalizado,
});
